module.exports = __webpack_public_path__ + "img/bg-milestone-done.21a1287d.png";